import React, { FC } from 'react';
import classNames from 'classnames';

import getClassNames from 'src/common/utils/getClassNames';
import styles from './DetailsList.module.scss';

export type DetailsListProps = {
  details: {
    termIsProminent: boolean;
    term: React.ReactNode;
    description: string;
  } [];
  variant?: 'smallDescription';
};

const DetailsList: FC<DetailsListProps> = ({
  details,
  variant,
}) => (
  <dl className={styles.root}>
    {details.map(({ term, termIsProminent, description }) => (
      <div
        key={description}
        className={styles.item}
      >
        <dt
          className={getClassNames(styles, 'term', termIsProminent ? 'prominent' : 'notProminent')}
          data-test="listHeading"
        >
          {term}
        </dt>
        <dd
          className={getClassNames(styles, 'description', classNames(variant, {
            prominent: !termIsProminent,
            notProminent: termIsProminent,
          }))}
          data-test="listDetail"
        >
          {description}
        </dd>
      </div>
    ))}
  </dl>
);

export default DetailsList;
